<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-07-16 17:17:08
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-05-08 10:41:55
-->
<template>
  <div :class="isQuantity ? 'head-info1' : 'head-info'">
    <div :class="center && 'center'">
      <div class="flex">
        <span :class="isTopmenu() && 'color-white-70'">{{ title }}</span>
        <a-icon
          v-if="sync"
          style="font-size: 14px; line-height: 26px; margin-left: 8px"
          :style="{ color: primaryColor }"
          type="sync"
          :spin="sync.loading"
          @click="refresh"
        />
      </div>
      <a-tooltip
        :placement="tooltip.position"
        :title="tooltip.content"
        :overlay-style="{ maxWidth: '500px' }"
      >
        <p :class="isTopmenu() && 'color-white'">{{ content }}</p>
      </a-tooltip>
      <em v-if="bordered" />
    </div>
  </div>
</template>

<script>
import { mixin } from "@/utils/mixin.js";
export default {
  name: "HeadInfo",
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: true,
    },
    sync: {
      type: [Object, Boolean],
      default: null,
    },
    tooltip: {
      type: Object,
      default: () => ({
        position: "top",
        content: "",
      }),
    },
    isQuantity: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    refresh() {
      this.$emit("refresh");
    },
  },
};
</script>

<style lang="scss" scoped>
.head-info {
  position: relative;
  text-align: left;
  padding: 0;
  min-width: 100px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
    margin-left: auto;
  }
  p {
    color: rgba(0, 0, 0, 0.85);
    font-size: 18px;
    line-height: 32px;
    margin: 0;
    text-align: right;
    cursor: pointer;
  }
  em {
    background-color: #e8e8e8;
    position: absolute;
    height: 56px;
    width: 1px;
    top: 0;
    right: 0;
  }
}
.head-info1 {
  position: relative;
  text-align: left;
  padding: 0;
  min-width: 100px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
    margin-left: auto;
  }
  p {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 16px;
    margin: 0;
    text-align: right;
    cursor: pointer;
  }
  em {
    background-color: #e8e8e8;
    position: absolute;
    height: 56px;
    width: 1px;
    top: 0;
    right: 0;
  }
  .color-white {
    color: #fff !important;
  }
  .color-white-70 {
    color: rgba(255,255,255,0.7) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tools/HeadInfo.vue